/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description PropertyType
 */

export enum PropertyType {
  UNKNOWN = 0,
  CONDO = 1,
  TOWNHOUSE = 2,
  COOP = 3,
  APARTMENT = 4,
  LOFT = 5,
  TIC = 6,
  MOBILE_MANUFACTURED = 7,
  FARM_RANCH = 8,
  MULTI_FAMILY = 9,
  INCOME_INVESTMENT = 10,
  HOUSEBOAT = 11,
  LOT_LAND = 12,
  SINGLE_FAMILY_HOME = 13,
  APARTMENT_CONDO_TOWNHOUSE = 14,
  FLOOR_PLAN = 15,
  ROOM = 16,
  SHARED_ROOM = 17,
  MANSIONS = 18,
  CABINS = 19,
  COTTAGE = 20,
  HOUSE_RENTALS = 21,
  VILLA = 22,
  BOAT = 23,
  LUXURY = 24,
  FARMHOUSE = 25,
  BUNGALOW = 26,
  GUEST_HOUSE = 27,
  HOTEL = 28,
}

Object.defineProperty(PropertyType, '__ENUM_NAME', {
  value: 'PropertyType',
  writable: false,
  configurable: false,
  enumerable: false,
})
